import { useUploaderPageData } from '../context/UploaderPageContext';
import { useUploaderListingsActions } from './useUploaderListingsActions';
import { useUploaderSpaceActions } from './useUploaderSpaceActions';

export const useUploaderActions = () => {
  const { isListing } = useUploaderPageData();

  const listingActions = useUploaderListingsActions();
  const spaceActions = useUploaderSpaceActions();

  const fetchMedia = isListing
    ? listingActions.fetchMedia
    : spaceActions.fetchMedia;

  const handleSave = isListing
    ? listingActions.handleSave
    : spaceActions.handleSave;

  const handlePhotoUpload = isListing
    ? listingActions.handlePhotoUpload
    : spaceActions.handlePhotoUpload;

  const handleDelete = isListing
    ? listingActions.handleDelete
    : spaceActions.handleDelete;

  const handleEmbedUpload = isListing
    ? listingActions.handleEmbedUpload
    : spaceActions.handleEmbedUpload;

  return {
    fetchMedia,
    handleSave,
    handlePhotoUpload,
    handleDelete,
    handleEmbedUpload
  };
};
